module.exports = __webpack_public_path__ + "img/Unit_Guide_half_pint.19e0558c.svg";